import StockTypeService from '../utilities/StockTypeUtil'

function format (key, quantity) {
    const stockType = StockTypeService.types[key]
    return (quantity === 1) ? stockType.noun : stockType.nounPlural
}

// Register filter on Vue instance
function install (Vue) {
    Vue.filter('stockType', format)
    Vue.prototype.$formatStockType = format
}

export default {
    format,
    install
}
